<po-page-default p-title="Chaves de Acesso" [p-breadcrumb]="breadcrumb"
    p-subtitle="Configurações de AccessKeys, SecretKeys e outras configurações para login em Sistemas Externos">
    <div class="po-row">
        <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
            <span class="an an-robot"></span>
            Configurações do Acesso</span>

        <div class="po-row po-mt-3">
            <po-container class="po-lg-12 po-md-12 po-sm-12">
                <div class="po-lg-11 po-md-9 po-sm-8">
                    <p class="po-font-subtitle">Chaves de Acesso</p>
                    <br />
                </div>
                <div class="po-row chaves-acesso-container">
                    <span class="chaves-label po-font-subtitle">Sistema Integra Contador:</span>
                    <po-input class="chaves-input po-lg-3" p-label="ConsumerKey" [(ngModel)]="consumerKey" p-placeholder="ConsumerKey"></po-input>
                    <po-input class="chaves-input po-lg-3" p-label="ConsumerSecret" [(ngModel)]="consumerSecret" p-placeholder="ConsumerSecret"></po-input>
                    <po-button p-label="Atualizar" (p-click)="atualizarChaves()" [p-disabled]="!isBotaoChavesHabilitado" [p-loading]="isLoadingChaves"></po-button>
                </div>
            </po-container>
        </div>
    </div>
</po-page-default>

